import {lazy, Suspense} from 'react';
import { Navigate, Route, Routes } from "react-router-dom";
const LoginPage = lazy(() => import("./pages/login.jsx"));
const CustomerHub = lazy(() => import('./pages/customer_hub.jsx'));
const LegacySubscriptionsRedirect = lazy(() => import('./pages/customer_hub.jsx').then(module => ({default:module.LegacySubscriptionsRedirect})));
const LegacyCustomerDetailRedirect = lazy(() => import('./pages/customer_hub.jsx').then(module => ({default:module.LegacyCustomerDetailRedirect})));
const TrialsPage = lazy(() => import("./pages/trials.jsx"));
const GeographyPage = lazy(() => import("./pages/geography.jsx"));
const ForecastingPage = lazy(() => import("./pages/forecasting.jsx"));
const DashboardPage = lazy(() => import("./pages/dashboard.jsx"));
const CustomerDetailPage = lazy(() => import("./pages/customer_detail.jsx"));
const CustomerHealthPage = lazy(() => import("./pages/customer_health.jsx"));
const DeactivationsPage = lazy(() => import("./pages/deactivations.jsx"));
const FranchisorsPage = lazy(() => import("./pages/franchisors.jsx"));
const FranchisorDetailPage = lazy(() => import("./pages/franchisor_detail.jsx"));
const CouponsPage = lazy(() => import("./pages/coupons.jsx"));
const CouponNewPage = lazy(() => import("./pages/coupon_new.jsx"));
const CouponEditPage = lazy(() => import("./pages/coupon_edit.jsx"));
const CouponDetailPage = lazy(() => import("./pages/coupon_detail.jsx"));
const PlaceholderPage = lazy(() => import("./pages/placeholder.jsx"));
const ReferralCampaignsPage = lazy(() => import("./pages/referral_campaigns.jsx"));
const ReferralPaymentsPage = lazy(() => import("./pages/referral_payments.jsx"));
const MessagingEconomicsPage = lazy(() => import("./pages/messaging_economics.jsx"));
import { HomeRedirect, RequireAuth } from "./auth/require_auth.jsx";
import AppLayout from "./layout/app_layout.jsx";

export default function App() {
  return (
    <Suspense fallback={<div className="p-6 text-sm text-[#9FB2C6]" role="status">Loading page…</div>}><Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route path="/" element={<HomeRedirect />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/geography" element={<GeographyPage />} />
        <Route path="/forecasting" element={<ForecastingPage />} />
        <Route path="/subscriptions" element={<LegacySubscriptionsRedirect />} />
        <Route path="/subscriptions/:clientId" element={<LegacyCustomerDetailRedirect />} />
        <Route path="/messaging-economics" element={<MessagingEconomicsPage />} />
        <Route path="/customers" element={<CustomerHub />} />
        <Route path="/customers/:clientId" element={<CustomerDetailPage />} />
        <Route path="/trials" element={<TrialsPage />} />
        <Route path="/customer-health" element={<CustomerHealthPage />} />
        <Route path="/deactivations" element={<DeactivationsPage />} />
        <Route path="/franchisors" element={<FranchisorsPage />} />
        <Route path="/franchisors/:franchisorId" element={<FranchisorDetailPage />} />
        {/* Billing Health is now a tab of Deactivations; keep old links working. */}
        <Route
          path="/billing-health"
          element={<Navigate to="/deactivations?tab=billing" replace />}
        />
        <Route path="/coupons" element={<CouponsPage />} />
        <Route path="/coupons/new" element={<CouponNewPage />} />
        <Route path="/coupons/:couponId/edit" element={<CouponEditPage />} />
        <Route path="/coupons/:couponId" element={<CouponDetailPage />} />
        <Route path="/referral-campaigns" element={<ReferralCampaignsPage />} />
        <Route path="/referral-payments" element={<ReferralPaymentsPage />} />
        <Route
          path="/settings"
          element={<PlaceholderPage title="Settings" subtitle="HQ configuration." />}
        />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes></Suspense>
  );
}
